import { z } from 'zod/v4';

import type { InfinexMessageNamespace } from './base';
import { generateEventSchema } from './schemaBuilder';

/** Only one heartbeat method: “ping” */
export const HeartbeatMethods = ['ping'] as const;
const namespace: InfinexMessageNamespace = 'heartbeat';

export const pingSchema = generateEventSchema({
  namespace,
  method: 'ping',

  // request exists but carries no data
  requestData: z.null(),
  // response exists but carries no data
  responseData: z.null(),
  // disallow any notification
  notificationData: z.never(),
});

/* ─────────────────── Aggregated schema arrays ─────────────────── */
export const heartbeatRequestParamSchemas = [
  pingSchema.requestParamsSchema,
] as const;

export const heartbeatResponseParamSchemas = [
  pingSchema.responseParamsSchema,
] as const;

export const heartbeatNotificationParamSchemas = [] as const; // none

export const heartbeatRequestEventSchemas = [pingSchema.requestSchema] as const;
export const heartbeatResponseEventSchemas = [
  pingSchema.responseSchema,
] as const;
export const heartbeatNotificationEventSchemas = [] as const; // none
